// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\VesselService\VesselServiceListingViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';
import { VesselStatus } from 'server/enums/VesselStatus';

// VesselServiceListingData is the class that VesselServiceListing serializes to/from
export interface VesselServiceListingData {
    SearchString : string | null;
    Status : VesselStatus | null;
	
    Vessels : VesselData[] | null;
	
}

// VesselServiceListingOptions is the class which may be passed to the VesselServiceListing constructor to define optional initial data values
export interface VesselServiceListingOptions {
    SearchString : string | null;
    Status : VesselStatus | null;
	
    Vessels? : VesselOptions[] | null;
	
}

export class VesselServiceListing {
    public SearchString : DataSignal<string | null>;
    public Status : DataSignal<VesselStatus | null>;
	
    public Vessels : SDataArray<Vessel>;
	

    constructor();
    constructor(data : VesselServiceListingOptions);
    constructor(data: VesselServiceListingOptions | null = null) {
        this.SearchString = jsonableObservable(S.value<string | null>(data && data.SearchString !== undefined ? data.SearchString : null));
        this.Status = jsonableObservable(S.value<VesselStatus | null>(data && data.Status !== undefined ? data.Status : null));
	    
        this.Vessels = SArray<Vessel>([]);
	    
    }

    static key(obj : VesselServiceListing) {
        return (obj.SearchString() === null ? '\u2603' : obj.SearchString()!) + '\u2618' + (obj.Status() === null ? NaN : obj.Status()!);
    }
    
    static dataKey(obj : VesselServiceListingOptions) {
        return (obj.SearchString === null ? '\u2603' : obj.SearchString) + '\u2618' + (obj.Status === null ? NaN : obj.Status);
    }

    static update(obj : VesselServiceListing, data : VesselServiceListingOptions) {
        S.freeze(() => {
            if (data.SearchString !== undefined) obj.SearchString(data.SearchString);
            if (data.Status !== undefined) obj.Status(data.Status);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/VesselServiceListing.ts